import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA, NgModule  } from '@angular/core';
import { DashCodeHelper } from '@app/_shared/_helpers/dashcode.helper';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';

@Component({
  selector: 'dashlayout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  currentUser;
  constructor(public dashcodeHelper:DashCodeHelper, private authenticationService: AuthenticationService) {

    this.authenticationService.currentUser.subscribe(
      (x) => (this.currentUser = x)
    );

   }

  ngOnInit(): void {
    // this.dashcodeHelper.documentReadyFunctions();
  }

}
